import Card from '@mui/joy/Card'
import Modal, { type ModalProps } from '@mui/joy/Modal'
import ModalClose from '@mui/joy/ModalClose'
import { type FC } from 'react'

const PaymentModal: FC<ModalProps> = ({ children, ...props }) => {
  return (
    <Modal
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      {...props}
    >
      <Card
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          padding: 0,
          width: { xs: '100%', md: 'auto' },
          maxWidth: { xs: '100vw', md: '95vw' },
          maxHeight: '95vh',
          overflow: 'auto',
          m: { xs: 0, md: 2 },
          borderRadius: { xs: 0, md: 'md' },
          '&:has(#stripe_checkout)': {
            width: { xs: '100%', md: 1080 },
            alignItems: 'stretch',
          },
        }}
      >
        <ModalClose sx={{ '--ModalClose-inset': '1rem' }} />
        {children}
      </Card>
    </Modal>
  )
}

export default PaymentModal
